import classNames from "classnames";
import { useTranslation } from "react-i18next";
import { MdOutlineArrowForward } from "react-icons/md";
import { NAME_SPACES } from "shared/locales/constants";

const ProcessPicker = ({ processes, onSelect }) => {
  const { t } = useTranslation(NAME_SPACES.PRIVATE.BROKER.PROJECT);
  const GENERATE_LINK = t("LIST.SUBSCRIPTION.GENERATE_SUBSCRIPTION_LINK", {
    returnObjects: true,
  });

  return (
    <div className="d-flex flex--column gap-12">
      <p className="process-picker__description">
        {GENERATE_LINK.PICK_PROCESS ||
          "Plusieurs parcours sont disponibles. Veuillez choisir le parcours cible."}
      </p>
      {processes.map((proc) => (
        <div
          key={proc.id}
          className={classNames(
            "process-picker__card",
            "d-flex",
            "align--center",
            "justify--between",
            "p-16",
            "gap-12",
          )}
          onClick={() => onSelect(proc)}
          role="button"
          tabIndex={0}
          onKeyDown={(e) => {
            if (e.key === "Enter" || e.key === " ") onSelect(proc);
          }}
        >
          <div className="d-flex flex--column gap-4">
            <strong className="process-picker__card-name">{proc.name}</strong>
          </div>
          <MdOutlineArrowForward size={20} />
        </div>
      ))}
    </div>
  );
};

export default ProcessPicker;
